module.exports = __webpack_public_path__ + "img/Stortingsmelding-nr.-31_Portrett-av-Halvdan-Koht.ae60b247.jpg";